<template>
  <ion-app>
    <ion-router-outlet />
    <AppUpdateNotification />
  </ion-app>
</template>

<script>
import { IonApp, IonRouterOutlet } from '@ionic/vue';
import { defineComponent } from 'vue';
import AppUpdateNotification from './components/AppUpdateNotification.vue';

export default defineComponent({
  name: 'App',
  components: {
    IonApp,
    IonRouterOutlet,
    AppUpdateNotification
  },

});

</script>